export default __webpack_public_path__ + "static/media/limao2.55257d49.png";